import React from 'react'
import {
  BlockNumber,
  UnblockNumber,
} from '~/components/compositional/QuickActions'

import { useToggleBlockedNumberButtonViewModel } from './ToggleBlockedNumberButton.viewmodel'

interface ToggleBlockedNumberButtonProps {
  phoneNumber: string | undefined
}

export const ToggleBlockedNumberButton = ({
  phoneNumber,
}: ToggleBlockedNumberButtonProps) => {
  const {
    canBlockNumber,
    isNumberBlocked,
    isBlocking,
    isUnblocking,
    blockNumberWithConfirmation,
    unblockNumber,
  } = useToggleBlockedNumberButtonViewModel(phoneNumber)

  if (!canBlockNumber) {
    return null
  } else if (isNumberBlocked) {
    return (
      <UnblockNumber
        key="unblock"
        onClick={() => {
          if (isBlocking || isUnblocking) {
            return
          }
          unblockNumber()
        }}
      />
    )
  } else {
    return (
      <BlockNumber
        key="block"
        onClick={() => {
          if (isBlocking || isUnblocking) {
            return
          }
          blockNumberWithConfirmation()
        }}
      />
    )
  }
}
